var a = +new Date(), n = 0;
function t() {
  return "rc-upload-".concat(a, "-").concat(++n);
}
export {
  t as default
};
//# sourceMappingURL=uid.mjs.map
